<script>
  export default {
    props: {
      filters: {
        default: null
      },
      excludes: {
        type: Array,
        default: () => []
      }
    },
    computed: {
      filteredRanges: {
        get() {
          return this.queries.date.map((o) => this.moment(o, 'YYYY-MM-DD'))
        },
        set(val) {
          this.queries.date = val.map((moment) => moment.format('YYYY-MM-DD'))
        }
      },
    },
    data: () => ({
      labelCol: { span: 4 },
      wrapperCol: { span: 16 },
      queries: {
        q: '',
        page: 1,
        per_page: 10,
        date: [],
        billers: [],
        products: [],
      }
    }),
    methods: {
      autocomplete(v, iteratee) {
        if (v.length === 0) {
          this.queries[iteratee] = []
        } else {
          this.queries[iteratee] = _.map(v, (o) => o.id)
        }
      },
      submit() {
        this.$emit("filtered", this.queries)
      },
      reset() {
        this.queries = {
          page: 1,
          per_page: 10,
          q: '',
          products: [],
          billers: [],
          date: [],
          type: '',
        }

        this.submit()
      },
      handleChange(value) {
        this.queries.type = value
      },
    },
    watch: {
      filters: {
        deep: true,
        immediate: true,
        handler: function(v) {
          if (v instanceof Object)
            Object.assign(this.queries, v)
        }
      }
    }
  }
</script>
<template>
  <a-card type="inner" size="small" :bordered="false">
    <a-form-model :model="queries" :label-col="labelCol" :wrapper-col="wrapperCol">

      <a-form-model-item label="Date">
        <a-range-picker :ranges="dateRanges" format="YYYY-MM-DD" v-model="filteredRanges" style="width: 100%"/>
      </a-form-model-item>

      <!-- <a-form-model-item label="Products" v-if="! excludes.includes('products')">
        <product-autocomplete style="width: 100%" @change="(item) => autocomplete(item, 'products') "/>
      </a-form-model-item> -->

      <a-form-model-item label="Billers" v-if="! excludes.includes('billers')">
        <biller-autocomplete style="width: 100%" @change="(item) => autocomplete(item, 'billers') "/>
      </a-form-model-item>

      <a-form-model-item label="Tipe">
        <a-select style="width: 100%" @change="handleChange">
          <a-select-option value="profit">
            Profit
          </a-select-option>
          <a-select-option value="biller_profit">
            Biller Profit
          </a-select-option>
          <a-select-option value="biller_amount">
            Biller Amount
          </a-select-option>
          <a-select-option value="sponsor_profit">
            Sponsor Profit
          </a-select-option>
        </a-select>
      </a-form-model-item>

      <a-form-model-item :wrapper-col="{ span: 18, offset: 4}">
        <a-button type="primary" @click="submit" icon="filter">Filter</a-button>
        <a-button class="ml-2" icon="reload" @click="reset">Reset</a-button>
      </a-form-model-item>
    </a-form-model>
  </a-card>
</template>
